export const getApiUrl = () => {
  //return 'https://uuuxy8rhm2.execute-api.us-west-1.amazonaws.com/development/api';
  return 'https://api.scvdebateclub.com/api';
  //return 'http://localhost:3000/development';
};
export const getImageUrl = () => {
  return 'https://images.scvdebateclub.com/assets/imgs';
};
